interface CustomSelectProps {
	options?: {
    value: string;
    label: string;
	}[];
	value?: string;
	onChange?: (value: string) => void
}

export const CustomSelect = ({ options, value, onChange }: CustomSelectProps) => {
	return (
		<select 
			required
			className="custom-select"
			onChange={(e) => onChange?.(e.target.value)}
			value={value || '0:00'}
		>
			{options?.map((el) => (
				<option key={el.value} value={el.value}>{el.label}</option>
			))}
		</select>
	);
};